<template>
  <div class="w-full">
    <div
      class="relative border-1 rounded-2xl min-w-full min-h-[60vh] tablet:min-h-[80vh] laptop:min-h-[100vh] 2xl:min-h-[80vh] flex flex-col gap-2 px-2 pt-4 pb-5 tablet:!pb-[70px] laptop:!pb-5 border-gray-300">
      <div
        class="z-[9] mobile:w-full right-0 mobile:left-0 mx-auto flex tablet:justify-between items-center gap-2 absolute -top-6 tablet:left-auto px-2.5">
        <div>
          <button @click="viewAffiliateClicked()"
            class="hidden desktop:!flex group  items-center gap-[10px] rounded-full px-[20px] py-[5px] shadow-[0_0_10px_0_rgba(0,0,0,0.15)] bg-[#fff] hover:bg-[#2359A8] transition duration-300">
            <img src="../../assets/images/network-affiliate-button-icon.svg" alt="Affiliate Icon"
              class="w-[24px] h-[24px] object-contain group-hover:!hidden transition duration-300">
            <img src="../../assets/images/network-affiliate-button-hover-icon.svg" alt="Affiliate Icon"
              class="w-[24px] h-[24px] object-contain hidden group-hover:!block transition duration-300">
            <span class="text-[18px] text-[#333] group-hover:text-[#fff] transition duration-300">Network Tree</span>
          </button>
        </div>
        <div class="flex items-center gap-[10px] w-full tablet:w-auto">
          <entities :modelValue="limit" @update:modelValue="onLimitChange" globalEntitiesClass="'tablet:w-[45%]'" />
          <searchInput :globalSearchClass="'mobile:w-full tablet:!w-[55%]'"
            :input-class="'rounded-full shadow-[0px_0px_10px_0px_#00000026] pl-3 pr-16 py-3 w-full h-10 bg-white disabled:!bg-white disabled:opacity-100 focus:outline-none text-sm'"
            :buttonclass="'absolute top-[5px] right-[5px] w-[30px] h-[30px]'"
            :img-src="require('@/assets/images/search-icon-01.png')"
            :clearClass="'absolute top-0 flex items-center justify-center !h-[100%] right-[2.2rem] laptop:w-4 laptop:h-4 largeDesktop:w-6 largeDesktop:h-6'"
            v-model="search" @input="onSearch" :onClear="onClearSearch" :readonly="loading" :clearable="true" />
          <div v-if="this.affiliateType != 'employee'" @click="addClicked" id="tour-add-affiliate"
            class="transform lg:hover:scale-[1.1] active:scale-[0.98] duration-300 transition-all group rounded-full min-h-[40px] min-w-[40px] max-h-[40px] max-w-[40px] cursor-pointer flex items-center justify-center border !border-[#14C38E] mobile:bg-[#14C38E] laptop:bg-white mobile:text-white laptop:text-[#14C38E] laptop:hover:bg-[#14C38E] laptop:hover:text-white">
            <img src="../../assets/images/add-green-circle.svg" alt="Add Icon"
              class="w-[24px] h-[24px] laptop:group-hover:hidden mobile:hidden laptop:block">
            <img src="../../assets/images/add-white-circle.svg" alt="Add Icon"
              class="w-[24px] h-[24px] laptop:group-hover:block mobile:block laptop:hidden">
          </div>
        </div>
      </div>
      <div class="laptop:hidden block">
        <div v-if="tableItems.length > 0" class="mt-2">
          <affiliatesList v-for="(item, index) in tableItems" :key="index" :item="item" @update="onActionClicked" />
        </div>
        <div v-else>
          <h6
            class="flex justify-center items-center text-[20px] laptop:text-[30px] min-h-[60vh] tablet:min-h-[80vh] laptop:min-h-[100vh] 2xl:min-h-[80vh] m-0 text-[#333333]"
            v-if="tableItems == null || (tableItems && tableItems.length == 0)">
            No Record Found
          </h6>
        </div>
      </div>
      <div class="mt-2 laptop:block mobile:hidden z-[2]">
        <affiliatesTable :tableHeaders="tableHeaders" :tableData="tableItems" :sortClicked="sortClicked"
          @update="onActionClicked" />
      </div>
    </div>
    <div v-if="tableItems && tableItems.length > 0"
      class="flex mobile:flex-col tablet:flex-row mobile:gap-3 tablet:gap-0 items-center justify-between relative -top-5 px-3">
      <paginationEntries class="mobile:hidden tablet:block" :currentPage="page" :perPage="limit"
        :totalItems="totalItems" />
      <customPagination :page="page" :total_pages="total_pages" :updatePage="updatePage" />
    </div>
  </div>

  <!-- Contractor Modal Modal -->
  <listingAddModal ref="addAffiliateModal" @update="updateList" />


</template>

<script>
import { mapActions, mapGetters } from "vuex";
import entities from "../../components/showEntities/entities.vue";
import searchInput from '../../components/partialComponent/customInput.vue';
import affiliatesTable from './affiliatesTable.vue';
import affiliatesList from "../../components/nest_components/omegaAffiliate/listing.vue";
// import createQoute from "../../components/createQuote/createQuote.vue";
import customPagination from "../../components/partialComponent/customPagination.vue";
import listingAddModal from "../../components/nest_components/omegaAffiliate/listingAddModal.vue";
import paginationEntries from "../../components/partialComponent/pagination-entries.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  components: {
    entities,
    searchInput,
    affiliatesTable,
    // createQoute,
    customPagination,
    paginationEntries,
    affiliatesList,
    listingAddModal
  },
  data() {
    return {
      limit: 25,
      search: "",
      page: 1,
      total_pages: 0,
      totalItems: 0,
      debounceTimer: null,
      loading: false,
      tableHeaders: [],
      tableItems: [],
      selectedSort: {
        "column": "id",
        "direction": "DESC"
      },
      affiliateType: ''
    }
  },
  computed: {
    ...mapGetters([
      "affiliateList",
      "updateAffiliateResponse",
      "updateAffiliateResp",
      "resendInviteResponse"
    ]),
  },
  watch: {
    affiliateList: function (data) {
      this.loading = false
      this.tableItems = this.affiliateList.body
      this.total_pages = this.affiliateList.paging.total_pages
      this.totalItems = this.affiliateList.paging.total_records
    },

    updateAffiliateResponse: function (data) {
      toast.success("Updated Successfully.");
      this.updateList()
    },
    updateAffiliateResp: function (data) {
      toast.success(data);
      this.updateList()
    },

    resendInviteResponse: function (data) {
      toast.success("Invite has been sent successfully.");
    },
  },
  mounted() {

    let user_ = JSON.parse(localStorage.getItem('user'))
    this.affiliateType = user_.user.affiliate?.affiliate_type ?? 'master'
    console.log("user", this.affiliateType)
    this.setTableHeaders();
    this.loading = true
    this.getAffiliateList({
      "search": this.search,
      "limit": this.limit,
      "page": this.page,
      "sort": this.selectedSort,
    });
  },
  methods: {
    ...mapActions([
      "updateAffiliateStatus",
      "getAffiliateList",
      "updateNormalAffiliateUpsert",
      "updateEmployeeAffiliateUpsert",
      "resendInvite"
    ]),
    updatePage(page) {
      if (page == this.page) return
      this.page = page
      this.loading = true
      this.getAffiliateList({
        "search": this.search,
        "limit": this.limit,
        "page": this.page,
        "sort": this.selectedSort,
      });
    },

    updateList() {
      clearTimeout(this.debounceTimer);
      // Start new debounce timer

      this.page = 1
      this.search = ''
      this.loading = true
      this.getAffiliateList({
        "search": this.search,
        "limit": this.limit,
        "page": this.page,
        "sort": this.selectedSort,
      });
    },
    onSearch() {
      clearTimeout(this.debounceTimer);
      // Start new debounce timer

      this.page = 1
      this.debounceTimer = setTimeout(() => {
        if (this.search.length == 0 || this.search.trim().length > 0) {
          this.loading = true
          this.getAffiliateList({
            "search": this.search,
            "limit": this.limit,
            "page": this.page,
            "sort": this.selectedSort,
          });
        }
      }, 1000); // 1200ms delay
    },
    onClearSearch() {
      clearTimeout(this.debounceTimer);
      this.page = 1
      this.search = ''
      this.loading = true
      this.getAffiliateList({
        "search": this.search,
        "limit": this.limit,
        "page": this.page,
        "sort": this.selectedSort,
      });

    },
    onLimitChange(newLimit) {
      this.limit = newLimit;
      this.page = 1;
      this.loading = true;
      this.getAffiliateList({
        search: this.search,
        limit: this.limit,
        page: this.page,
        sort: this.selectedSort,
      });
    },
    setTableHeaders() {
      this.tableHeaders = [
        // this.getTableHeaderObject("ID", "id", "id", "", "1"),
        this.getTableHeaderObject("Name", "first_name", "first_name", "", "1"),
        this.getTableHeaderObject("Email", "email", "email", "", "1"),
        this.getTableHeaderObject("Phone", "phone", "phone", "", "1"),
        this.getTableHeaderObject("Commission Type", "distribution_frequency_text", "distribution_frequency_text", "", "1"),
        this.getTableHeaderObject("Affiliate Type", "affiliate_type_name", "affiliate_type_name", "", "1"),
        this.getTableHeaderObject("Stripe", "stripe", "stripe", "", "1"),
        this.getTableHeaderObject("Last Login", "last_login_at", "last_login_at", "", "1"),
        this.getTableHeaderObject("Status", "active", "active", "", "1"),
        this.getTableHeaderObject("Action", "action", "action", "", "0"),
      ]
      this.setSort()
    },
    getTableHeaderObject(title, data_value, sort_column, sort_direction, sort_applicable, isHeaderToolTipShow = 0, tooltip_text = '') {
      return {
        title: title,
        data_value: data_value,
        sort_column: sort_column,
        sort_direction: sort_direction,
        sort_applicable: sort_applicable,
        isHeaderToolTipShow: isHeaderToolTipShow,
        tooltip_text: tooltip_text
      }
    },
    setSort() {
      this.tableHeaders.map(obj => {
        if (obj.sort_column == this.selectedSort.column) {
          obj.sort_direction = this.selectedSort.direction;
        } else {
          obj.sort_direction = "";
        }
      });
    },
    sortClicked(item) {
      if (item.sort_applicable == '1') {
        this.page = 1
        if (item.sort_column == this.selectedSort.column) {
          this.selectedSort.direction = item.sort_direction == "DESC" ? "ASC" : "DESC"
          item.sort_direction = this.selectedSort.direction
        } else {
          this.tableHeaders.map(obj => {
            obj.sort_direction = "";
          });
          this.selectedSort.column = item.sort_column
          this.selectedSort.direction = item.sort_direction == "DESC" ? "ASC" : "DESC"
          item.sort_direction = this.selectedSort.direction
        }
        this.getAffiliateList({
          search: this.search,
          limit: this.limit,
          page: this.page,
          sort: this.selectedSort,
        })
      }
    },

    addClicked() {
      this.$refs.addAffiliateModal.
        openModal()
    },

    viewAffiliateClicked() {
      this.$router.push({ name: 'networkAffiliate' });
    },

    onActionClicked(data, option) {
      if (option == 'Active') {
        this.$dialog.show({
          title: "Update",
          text: "Are you sure you want to update status?",
          onConfirm: () => {
            this.updateAffiliateStatus({
              id: data.id,
              status: 1
            })
          },
        });
      } else if (option == 'Inactive') {
        this.$dialog.show({
          title: "Update",
          text: "Are you sure you want to update status?",
          onConfirm: () => {
            this.updateAffiliateStatus({
              id: data.id,
              status: 0
            })
          },
        });
      }
      else if (option == 'Edit') {
        this.$refs.addAffiliateModal.
          editModal(data)
      }
      else if (option == 'Resend Invite') {
        this.resendInvite({ id: data.id })
      }
      else if (option == 'Mark as Standard') {
        this.$dialog.show({
          title: "Are you sure you want to mark this affiliate as Standard?",
          text: "When marking the affiliate as Standard, they will be eligible for commission.",
          onConfirm: () => {
            this.updateNormalAffiliateUpsert({
              id: data.id,
            })
          },
        });
      }
      else if (option == 'Mark as Employee') {
        this.$dialog.show({
          title: "Are you sure you want to mark this affiliate as Employee?",
          text: "When marking the affiliate as Employee, they will not be eligible for commission.",
          onConfirm: () => {
            this.updateEmployeeAffiliateUpsert({
              id: data.id,
            })
          },
        });
      }
      // else if (option == 'View Affiliate Tree') {
      //   if (window.innerWidth >= 1320) {
      //     this.$router.push({ name: 'networkAffiliate', params: { id: data.id } });
      //   }
      // }

    }
  },
};
</script>